import React from "react";
import Rooms from "./Rooms";

const Ourrooms = () => {
  return (
    <div className="ourrooms display-flex-column relative">
      <p className="Ourrooms-heading">OUR ROOMS</p>
      <img
        loading="lazy"
        className="ourrooms-logo-heading"
        src="/Assets/experience-logo.webp"
        alt="group615img"
      ></img>

      <Rooms />

      <p className="rooms-heading1">Your Comfort is Our Priority</p>
      <p className="ourrooms-text">
        At Surya vilas palace , we pride ourselves on providing an exceptional
        stay for every guest. Our range of luxurious and comfortable rooms is
        designed to cater to your every need, whether you're here for business
        or leisure. We understand that every guest is unique, and we go above
        and beyond to ensure your stay is memorable and enjoyable.
      </p>
      <img
        loading="lazy"
        className="our-rooms-logo"
        src="/Assets/logonew.webp"
        alt="logo"
      ></img>
    </div>
  );
};

export default Ourrooms;
